import { useQuery } from '@tanstack/react-query';
import type { J5RegistryV1ArtifactKeys } from '@interxfi/types/generated/api';
import { useRealmAuthIsAuthenticated } from '../context';
import { j5RegistryV1ArtifactCommandServiceArtifactDownload } from '../generated/client-functions/j5-registry-v1-artifact-command-service-artifact-download';
import { buildJ5RegistryV1ArtifactCommandServiceArtifactDownloadKey } from '../generated/hooks/j5-registry-v1-artifact-command-service-artifact-download';
import { getRegistryBaseUrl } from './registry';

function buildJ5ArtifactDownloadKey(keys: J5RegistryV1ArtifactKeys | undefined) {
  const base = [...buildJ5RegistryV1ArtifactCommandServiceArtifactDownloadKey()] as const;
  if (!keys) {
    return base;
  }

  return [...base, keys.owner, keys.bundle, keys.version, keys.name] as const;
}

export function getJ5ArtifactDownloadQueryOptions(keys: J5RegistryV1ArtifactKeys | undefined) {
  return {
    queryKey: buildJ5ArtifactDownloadKey(keys),
    queryFn: () => j5RegistryV1ArtifactCommandServiceArtifactDownload(getRegistryBaseUrl(), keys),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    refetchOnReconnect: false,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
  } as const;
}

export function useApiArtifactDownload(keys: J5RegistryV1ArtifactKeys | undefined) {
  const isAuthenticated = useRealmAuthIsAuthenticated();

  return useQuery({
    ...getJ5ArtifactDownloadQueryOptions(keys),
    enabled: Boolean(keys && isAuthenticated),
  });
}
